//------ 主题变化事件 开始------
/**
 * CAD 主题模式枚举。
 */
export enum CadThemeMode {
    /** 亮色主题模式。 */
    Light = 'light',
    /** 暗色主题模式。 */
    Dark = 'dark',
}

/**
 * CAD 主题来源枚举。
 */
export enum CadThemeSource {
    /** 用户显式选择亮色主题。 */
    LightTheme = 'lightTheme',
    /** 用户显式选择暗色主题。 */
    DarkTheme = 'darkTheme',
    /** 用户选择跟随操作系统主题。 */
    OsTheme = 'osTheme',
}

/**
 * CAD 主题视口背景色枚举。
 */
export enum CadThemeViewportBackgroundColor {
    /** 亮色主题视口纯白背景。 */
    Light = '#ffffff',
    /** 暗色主题视口深灰背景。 */
    Dark = '#333333',
}

/**
 * 主题事件名称枚举。
 */
export enum ThemeEventName {
    /** CAD 主题已经变化。 */
    ThemeChanged = 'themeChanged',
}

/**
 * 主题变化事件载荷。
 */
export interface ThemeChangedEventPayload {
    /** 当前解析后的主题模式。 */
    readonly mode: CadThemeMode;
    /** 当前主题来源。 */
    readonly source: CadThemeSource;
    /** 当前视口背景色。 */
    readonly viewportBackgroundColor: CadThemeViewportBackgroundColor;
}

/**
 * 主题事件注册列表。
 */
export const themeEventNames: IEventBus.CadEventName[] = [
    ThemeEventName.ThemeChanged,
];
//------ 主题变化事件 结束------
